/* eslint-disable @typescript-eslint/unbound-method */
import { Component, EventEmitter, Input, Output, type OnInit } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../services/cms.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { FormBuilder, FormControl, type FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { States } from '../../enums/states.enum';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { type Address } from '../../models/address';

@Component({
  selector: 'app-mailing-address',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatRadioModule,
  ],
  templateUrl: './mailing-address.component.html',
  styleUrl: './mailing-address.component.scss',
})
export class MailingAddressComponent implements OnInit {
  @Input() mailingAddressData: any;
  @Input() unverifiedAddress: any;
  @Output() dataEmitter = new EventEmitter<boolean>();
  pageLabels: any;
  mailingAddressForm!: FormGroup;
  isMultiAccount = false;
  pageReady = false;
  stateArray = Object.values(States);
  addressList: Address[] = [];
  prevValue: string = '';
  constructor(
    private readonly cms: CmsService,
    private readonly formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.cms.getContent('oas-mailing-address-component', 'OAS Mailing Address Component').subscribe((data) => {
      this.pageLabels = data;
      this.addressList = this.mailingAddressData.addressList;
      this.isMultiAccount = this.mailingAddressData.isMultiAccount;
      this.mailingAddressForm = this.mailingAddressData.formGroup;
      this.pageReady = true;
    });
  }

  get address1(): FormControl {
    return this.mailingAddressForm.get('address1') as FormControl;
  }

  get address2(): FormControl {
    return this.mailingAddressForm.get('address2') as FormControl;
  }

  get city(): FormControl {
    return this.mailingAddressForm.get('city') as FormControl;
  }

  get postalCode(): FormControl {
    return this.mailingAddressForm.get('postalCode') as FormControl;
  }

  get state(): FormControl {
    return this.mailingAddressForm.get('state') as FormControl;
  }

  get setDefault(): FormControl {
    return this.mailingAddressForm.get('setDefault') as FormControl;
  }

  get addressRadioGroup(): FormControl {
    return this.mailingAddressForm.get('addressRadioGroup') as FormControl;
  }

  updateForm(value: any): void {
    this.mailingAddressForm.get('address1')?.setValue(value.Address1);
    this.mailingAddressForm.get('address2')?.setValue(value.Address2);
    this.mailingAddressForm.get('city')?.setValue(value.City);
    this.mailingAddressForm.get('postalCode')?.setValue(value.PostalCode);
    this.mailingAddressForm.get('state')?.setValue(value.State);
  }

  checkFormChanges(): void {
    if (this.mailingAddressForm.get('addressRadioGroup')?.value) {
      this.mailingAddressForm.get('addressRadioGroup')?.setValue(null);
    }

    if (this.unverifiedAddress) {
      this.dataEmitter.emit(true);
    }
  }
}
